import React, { useEffect, useState } from "react";
import { Collapse, Form, InputGroup } from "react-bootstrap";
import { CiFilter } from "react-icons/ci";
import SplitPane from "react-split-pane";
import { BiCollapse, BiExpand } from "react-icons/bi";
import SDATableProperties from "./SDATableProperties";
import SDATableData from "./SDATableData";
import { CgChevronDown } from "react-icons/cg";
import { AiOutlinePlus } from "react-icons/ai";
import { TbLayoutSidebarRightExpand } from "react-icons/tb";
import AddDatasetPropertyTable from "./AddDatasetPropertyTable";
import { GoSearch } from "react-icons/go";
import { cdiscServices } from "../../../../../Services/CDISC/cdiscServices";
import UseToggle from "../../../../../Hooks/UseToggle";
import { useParams } from "react-router";
import CellDatasetVariable from "./CellDatasetVariable";
import {
  NoDataFoundTable,
  SpinerDataLoader,
} from "../../../../NoDataFoundTable/NoDataFoundTable";

const Datasets = ({ onMouseDown, tableRef, handleAddNewTab }) => {
  const [loader, setLoader] = useState(false);
  const { toggle, setToggle } = UseToggle();
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [stdmDataSets, setSTDMDataSets] = useState([]);
  const [isOpenProperty, setIsOpenProperty] = useState(false);
  const [isHalfScreen, setIsHalfScreen] = useState(false);
  const [activeTabs, setActiveTabs] = useState("properties");
  const [openFilter, setOpenFilter] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [domainId, setDomainId] = useState("");
  const [domain, setDomain] = useState("");
  const { studyId } = useParams();

  const toggleHalfScreen = () => {
    setIsHalfScreen(!isHalfScreen);
  };

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const getCDISCDatasets = async () => {
    setLoader(true);
    let data = await cdiscServices.getCDISCDatasets(studyId);
    setSTDMDataSets(data?.data || []);
    setLoader(false);
  };

  useEffect(() => {
    getCDISCDatasets();
  }, []);

  return (
    <div className={`code-list-container ${isFullScreen ? "full-screen" : ""}`}>
      <div className="p-1 hstack justify-content-between border-bottom toolbar">
        <div className="hstack gap-2">
          <i
            title="Table Properties"
            className="fa-solid fa-list CP"
            onClick={setToggle}
          />
          <div className="vr"></div>
          <i
            className="fa-solid fa-magnifying-glass"
            title="Search"
            onClick={() => setOpenFilter(!openFilter)}
          ></i>
          <Collapse in={openFilter} dimension="width">
            <div>
              <InputGroup style={{ width: 200 }}>
                <Form.Control
                  type="search"
                  className="px-2"
                  placeholder="Search..."
                  style={{ fontSize: 10, borderRadius: "0", padding: 0 }}
                />
                <InputGroup.Text
                  id="basic-addon2"
                  style={{ padding: "1px 5px" }}
                >
                  <GoSearch />
                </InputGroup.Text>
              </InputGroup>
            </div>
          </Collapse>
        </div>
        {isFullScreen ? (
          <i className="fa-solid fa-maximize" title="Original Mode" onClick={toggleFullScreen}></i>
        ) : (
          <i className="fa-solid fa-minimize" title="Full Mode" onClick={toggleFullScreen}></i>
        )}
      </div>
      <div className="position-relative">
        <SplitPane
          split="horizontal"
          style={{
            height: isFullScreen ? "calc(100vh - 35px)" : "calc(100vh - 148px)",
          }}
          defaultSize={isOpenProperty ? "40%" : "100%"}
        >
          <SplitPane split="vertical" minSize={20} defaultSize={"100%"}>
            <>
              {loader ? (
                <SpinerDataLoader />
              ) : stdmDataSets?.length === 0 ? (
                <NoDataFoundTable MSG={" Dataset Not Found!"} />
              ) : (
                <SDATableData
                  studyId={studyId}
                  stdmDataSets={stdmDataSets}
                  handleAddNewTab={handleAddNewTab}
                  getCDISCDatasets={getCDISCDatasets}
                  setIsOpenProperty={setIsOpenProperty}
                  onMouseDown={onMouseDown}
                  tableRef={tableRef}
                  setDomainId={setDomainId}
                  setDomain={setDomain}
                />
              )}
            </>
          </SplitPane>
          {isOpenProperty && (
            <div
              className={`${isHalfScreen ? "full-screen" : ""}`}
              style={{ height: "100%" }}
            >
              <div
                className="hstack justify-content-between border-bottom px-2 pb-0 bg-light"
                style={{ padding: 5 }}
              >
                <div className="hstack me-1 gap-1">
                  {["properties", "cell Variable"].map((tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${
                        activeTabs === tab ? "activee" : ""
                      }`}
                      onClick={() => setActiveTabs(tab)}
                      title={
                        tab === "cell Variable"
                          ? domain +
                            " " +
                            tab.charAt(0).toUpperCase() +
                            tab.slice(1)
                          : tab.charAt(0).toUpperCase() + tab.slice(1)
                      }
                      style={{ borderRadius: "3px 3px 0px 0px" }}
                    >
                      {tab === "cell Variable"
                        ? domain +
                          " " +
                          tab.charAt(0).toUpperCase() +
                          tab.slice(1)
                        : tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  ))}
                </div>
                <div className="hstack gap-1">
                  <button
                    className={`tabButtons border-0 fs-13 px-2`}
                    style={{ borderRadius: "3px 3px 0px 0px" }}
                    title={"Hide"}
                    onClick={() => setIsOpenProperty(false)}
                  >
                    <CgChevronDown />
                  </button>
                  <button
                    className={`tabButtons border-0 fs-13 px-2`}
                    style={{ borderRadius: "3px 3px 0px 0px" }}
                    title={!isHalfScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleHalfScreen}
                  >
                    {isHalfScreen ? <BiCollapse /> : <BiExpand />}
                  </button>
                </div>
              </div>
              {activeTabs === "properties" && (
                <div className="border-bottom p-2 pt-1 hstack gap-2">
                  <button
                    title={isFormOpen ? "Hide Form" : "Add Data"}
                    className="tabButtons fontSize12 border-0"
                    style={{ padding: "1px 5px" }}
                    onClick={() => setIsFormOpen(!isFormOpen)}
                  >
                    {isFormOpen ? (
                      <TbLayoutSidebarRightExpand />
                    ) : (
                      <AiOutlinePlus />
                    )}
                  </button>
                  <div className="vr"></div>
                  <button
                    title="Filter"
                    className="tabButtons fontSize12 border-0"
                    style={{ padding: "1px 5px" }}
                  >
                    <CiFilter />
                  </button>
                </div>
              )}
              <SplitPane
                split="horizontal"
                className="position-relative"
                defaultSize="90%"
              >
                {activeTabs === "properties" ? (
                  <AddDatasetPropertyTable isFormOpen={isFormOpen} 
                  onMouseDown={onMouseDown}
                  tableRef={tableRef}
                  />
                ) : activeTabs === "cell Variable" ? (
                  <CellDatasetVariable
                    isFormOpen={isFormOpen}
                    domainId={domainId}
                    studyId={studyId}
                    onMouseDown={onMouseDown}
                    tableRef={tableRef}
                  />
                ) : (
                  ""
                )}
              </SplitPane>
            </div>
          )}
        </SplitPane>
      </div>
      <SDATableProperties
        Show={!toggle}
        Hide={setToggle}
        Title={"Table Properties"}
      />
    </div>
  );
};

export default Datasets;
